import { createApp } from 'vue';
import { router } from './router';
import { store } from './store';
import App from './App.vue';
import vcl from '@langlois/vuejs-component-library';

createApp(App)
	.use(store)
	.use(router)
	.use(vcl, { store })
	.mount(`#app`);
